import {Button, Card, Form, Spin} from 'antd';
import React from "react";
import {getFormFieldByType, sanitizeFieldName} from "../../util/methods";
import SubList from "../../components/SubList";

class Create extends React.Component {

  componentDidMount() {
    const {match, fetch} = this.props;
    if(match.params && match.params.id) {
      fetch(match.params.id);
    }
  }


  handleSubmit = (e) => {
    const {match} = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if(err) {
        return console.log(err);
      }

      if(match.params && match.params.id) {
        this.props.onSubmit(values, match.params.id);
      } else {
        this.props.onSubmit(values);
      }
    });
  };

  render() {
    const {getFieldDecorator} = this.props.form;
    const {data, loading, filters, title, resource, form} = this.props;

    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title} ${sanitizeFieldName(resource)}`}>
          <Form onSubmit={this.handleSubmit} layout="vertical">

            {Object.keys(filters).map((item) => {
              if(filters[item].type === 'Array' && filters[item].schema) {
                return <SubList key={item} item={filters[item]} form={form} data={data[item]} title={title}
                                resource={resource}/>
              } else return getFormFieldByType(filters, item, getFieldDecorator, data, {title: this.props.title})

            })}

            <Form.Item>
              <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}>
                {this.props.title === 'EDIT' ? 'UPDATE' : 'CREATE'}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
